export enum CLIENT_TYPES {
	Business = 1,
	Residential = 2,
	Other = 3
}
